import 'core-js';

import { Deactivated } from './Deactivated';


function App() {
  return (
    <Deactivated/>
  );
}

export default App;
